import type { IconProps } from './types';
import './icons.css';

export default function IconConnection({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 11}
      height={height || 12}
      viewBox="0 0 11 12"
      className={`icon icon-connection ${className || ''}`}
    >
      <circle cx="2" cy="10.333" r="1.667" fill="currentColor" />
      <circle cx="2" cy="1.667" r="1.667" fill="currentColor" />
      <circle cx="8.667" cy="1.667" r="1.667" fill="currentColor" />
      <path
        d="m5.333 5.667-.147-.736.147.736Zm-4.083-3V10h1.5V2.667h-1.5ZM2.75 10c0-.501.142-1.317.566-2.05.41-.71
        1.076-1.33 2.164-1.548l-.294-1.47c-1.578.315-2.58 1.25-3.168 2.267A5.843 5.843 0 0 0 1.25
        10h1.5Zm2.73-3.598c1.852-.37 2.88-1.234 3.416-2.147a3.78 3.78 0 0 0 .52-1.922h-1.5c0 .127
        0 .63-.312 1.162-.297.503-.936 1.14-2.418 1.436l.294 1.471Z"
        fill="currentColor"
      />
    </svg>
  );
}
